<!--上传组件 Sag 2020-04-20-->
<template>
  <div :id="btn.id + '-container'">
    <div v-if="btn.custom" :id="btn.id" :class="btn.className">
      <slot></slot>
    </div>
    <button v-else :id="btn.id" :class="btn.className" title="按住ctrl键选择多个文件可同时上传">
      <slot></slot>{{btn.title}}
    </button>
  </div>
</template>

<script>
// import plupload from '../../../public/js/plupload/plupload.full.min'
import plupload from 'plupload'
import {rawRequest} from '../../utils/http'

export default {
  name: 'Upload',
  props: {
    btn: {
      type: Object,
      default: function () {
        return {title: '上传', className: 'ts-upload', id: 'ts-upload'}
      }
    },
    upload: {
      type: Object,
      default: function () {
        return {apiURL: 'http://yunti.xkw.com', url: 'http://oss.aliyuncs.com', fileType: 'Resource', savePath: 'CLASSSPACE'}
      }
    },
    format: {
      type: Object,
      default: function () {
        return {
          size: 100 * 1024 * 1024,
          accept: 'avi,rm,mp3,wav,mid,mpg,mp4,mpge,wma,rmvb,wmve' +
            // ',jpg,gif,bmp,png' +
            ',flv,swf,asf' +
            ',rar,zip' +
            ',xls,xlsx,csv' +
            ',doc,wps,docx' +
            ',ppt,dps,pptx,pdf',
          limit: 10
        }
      }
    },
    fatherAction: {
      type: Function,
      default: function () {
        return undefined
      }
    },
    selectedAction: {
      type: Function,
      default: undefined
    },
    onlyGetFiles: {// 只到获取文件这一步，不上传
      type: Boolean,
      default: function () {
        return false
      }
    },
    fileLimit: { // 当前允许上传的文件个数限制
      type: Number,
      default: 10
    },
    uploadLimit: {// 允许上传的文件总个数
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      uploader: {},
      defaultUploadUrl: 'http://oss.aliyuncs.com',
      // custom: 是否使用自定义按钮视图，默认是一个按钮 YuAng
      defaultBtn: {title: '上传', className: 'ts-upload', id: 'ts-upload', custom: false},
      defaultUpload: {
        apiURL: 'http://yunti.xkw.com',
        url: 'http://oss.aliyuncs.com',
        fileType: 'Resource',
        savePath: 'CLASSSPACE'
      },
      defaultFormat: {
        size: 100 * 1024 * 1024,
        accept: 'avi,rm,mp3,wav,mid,mpg,mp4,mpge,wma,rmvb,wmve' +
          // ',jpg,gif,bmp,png' +
          ',flv,swf,asf' +
          ',rar,zip' +
          ',xls,xlsx,csv' +
          ',doc,wps,docx' +
          ',ppt,dps,pptx,pdf',
        limit: 1,
        title: '备课资源类型'
      },
      isUploadToCloud: false,
      updateData: true,
      errorFileList: [],
      lastFile: null, // 最后上传的文件
      showFileList: [], // 页面显示的文件列表（包含可上传和不可上传）
      leftCanAdd: 0 // 剩余可上传文件数
    }
  },
  computed: {
    fileList: function () {
      var fileList = []
      for (let i = 0; i < this.uploader.files.length; i++) {
        let file = this.uploader.files[i]
        let extenstion = this.getLastName(file.name)
        let newFile = {
          raw: file,
          status: file.status,
          name: file.name.replace('.' + extenstion, ''), // 分离扩展名
          size: file.size,
          path: 'wait',
          uid: file.id,
          progress: 0,
          category: 1,
          extenstion: extenstion,
          image: 'wait'
        }
        fileList.push(newFile)
      }
      return fileList
    },
    btnTitle: function () {
      if (this.format.limit === 1 && this.uploader.files && this.uploader.files.length === 1) {
        return '重新上传'
      } else {
        return this.btn.title
      }
    }
  },
  created () {
    this.resetData()
  },
  mounted: function () {
    this.initUploader()
  },
  methods: {
    resetData: function () {
      if (this.upload) {
        for (let key in this.defaultUpload) {
          let value = this.upload[key]
          if (value === undefined) {
            value = this.defaultUpload[key]
            this.$set(this.upload, key, value)
          }
        }
      }
      this.isUploadToCloud = this.defaultUpload.url === this.upload.url
      if (this.format) {
        for (let key in this.defaultFormat) {
          let value = this.format[key]
          if (value === undefined) {
            value = this.defaultFormat[key]
            this.$set(this.format, key, value)
          }
        }
      }
      if (this.btn) {
        for (let key in this.defaultBtn) {
          let value = this.btn[key]
          if (value === undefined) {
            value = this.defaultBtn[key]
            this.$set(this.btn, key, value)
          }
        }
      }
    },
    initUploader: function () {
      let vm = this
      this.uploader = new plupload.Uploader({
        runtimes: 'html5,flash,silverlight,html4',
        browse_button: vm.btn.id,
        url: vm.upload.url,
        flash_swf_url: 'static/js/plupload/Moxie.swf',
        silverlight_xap_url: 'static/js/plupload/Moxie.xap',
        container: document.getElementById(vm.btn.id + '-container'),
        multipart: true,
        filters: {
          mime_types: [
            {title: vm.format.title, extensions: vm.format.accept}
          ],
          max_file_size: vm.format.size // 最大只能上传500mb的文件
        },
        multi_selection: vm.format.limit > 1, // 只支持选中单个文件
        multipart_params: {
          fileTypeEnum: vm.upload.fileType
        }
      })
      try {
        this.uploader.init()
      } catch (e) {
        console.debug('uploader is error:', e.message)
      }
      // 当文件添加到上传队列后触发
      this.uploader.bind('FilesAdded', function (up, files) {
        vm.previewPic(files)
        vm.filesAdded(files)
      })
      // 当队列中的某一个文件正要开始上传前触发
      this.uploader.bind('BeforeUpload', function (up, file) {
        return vm.beforeUpload(file)
      })
      this.uploader.bind('UploadProgress', function (up, file) {
        vm.uploadProgress(file)
      })
      this.uploader.bind('FileUploaded', function (up, file, info) {
        vm.fileUploaded(file, info)
      })
      this.uploader.bind('Error', function (up, err) {
        let message = ''
        let file = err.file
        if (err.code === -600) {
          vm.resetData()
          message = '文件大小不能为0KB或者超过' + vm.formatSize(vm.format.size)
          vm.addToFileList(file, message)
        } else if (err.code === -601) {
          message = '上传功能不支持该类型的文件'
          vm.addToFileList(file, message)
        } else if (err.code === -700) {
          message = '图片格式错误'
          vm.addToFileList(file, message)
        } else if (err.code === -602) {
          message = '选择的文件重复了'
          vm.addToFileList(file, message)
        } else if (err.code === -200) {
          message = '上传接口错误'
          // 这种情况可以重新上传
          if (vm.format.limit === 1) {
            vm.errorFileList = []
            vm.errorFileList.push(err.file)
          }
          if (vm.fatherAction) {
            vm.fatherAction({type: 'error', error: {message: message, code: err.code, fileList: [err.file]}})
          }
        }
      })
    },
    addToFileList: function (file, message) {
      file.status = 'error'
      file.errorMessage = message
      let fileName = file.name
      let extension = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length).toLowerCase()
      file.extension = extension
      file.fileName = fileName.substring(0, fileName.lastIndexOf('.')).substring(0, 150)
      if (this.showFileList.length < this.format.limit) {
        this.showFileList.push(file)
      }
      this.$emit('file-list', this.showFileList)
      // this.startUpload()
    },
    previewPic: function (addFiles) {
      /* eslint-disable */
      addFiles.forEach(function (file) {
        if (!file || !/image\//.test(file.type)) return // 确保文件是图片
        if (file.type === 'image/gif') { // gif使用FileReader进行预览,因为mOxie.Image只支持jpg和png
          let fr = new plupload.moxie.file.FileReader()
          fr.onload = function () {
            file.imgsrc = fr.result
            fr.destroy()
            fr = null
          }
          fr.readAsDataURL(file.getSource())
        } else {
          let preloader = new plupload.moxie.image.Image()
          preloader.onload = function () {
            // preloader.downsize(180, 120)// 先压缩一下要预览的图片
            let imgsrc = preloader.type === 'image/jpeg' ? preloader.getAsDataURL('image/jpeg', 80) : preloader.getAsDataURL() // 得到图片src,实质为一个base64编码的数据
            file.imgsrc = imgsrc
            preloader.destroy()
            preloader = null
          }
          preloader.load(file.getSource())
        }
      })
    },
    filesAdded: function (fileList) {
      // 文件类型和文件大小的验证插件本身已经做过了，如果用户需要再附加什么验证则自己添加
      if (fileList.length > this.format.limit) {
        if (this.fatherAction) {
          this.fatherAction({type: 'upload-limit', error: {message: '单次上传文件不能超过' + this.format.limit + '个', fileList: fileList}})
          fileList.forEach(file => {
            this.uploader.removeFile(file)
          })
          return false
        }
      }
      if (this.uploader.files.length > 0) {
        if (this.selectedAction) {
          // 用户验证
          this.selectedAction({uploadNum: this.showFileList.length + fileList.length, fileList: fileList, callback: this.fileFilter})
        } else {
          // 直接上传
          this.startUpload()
        }
      } else {
        if (this.fatherAction) {
          this.fatherAction({type: 'error', error: {message: '选择的文件不符合条件！', fileList: fileList}})
        }
      }
    },
    fileFilter: function (fileList, fileNum) {
      let _this = this
      // 校验上传列表
      fileList.forEach((file, i) => {
        // 文件类型
        let fileName = file.name
        let extension = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length).toLowerCase()
        file.extension = extension
        file.fileName = fileName.substring(0, fileName.lastIndexOf('.')).substring(0, 150)
         // 文件大小
        if (file.size < 1024 || file.size > this.format.size) {
          file.status = 'error'
          file.errorMessage = '文件大小不能小于1KB或者超过' + this.formatSize(this.format.size)
          this.uploader.removeFile(file)
        }
        if (this.fileLimit < 0) {
          if (this.showFileList.length >= (fileNum - Math.abs(this.fileLimit))) {
            // 超出的部分数据
            if (file.status !== 'error') {
              file.status = 'error'
              file.isUpper = true
              file.errorMessage = '很抱歉，您的章节存储份数已经超过个人普通版单个章节' + this.uploadLimit + '份的上限。'
              this.uploader.removeFile(file)
            }
          }
          // 上传列表不能超过十份
          if (this.showFileList.length < 10) {
            this.showFileList.push(file)
          } else {
            this.uploader.removeFile(file)
          }
        } else {
          this.showFileList.push(file)
        }
      })
      this.$emit('file-list', this.showFileList)
      this.startUpload()
    },
    startUpload: function () {
      if (this.onlyGetFiles) {
        if (this.fatherAction !== undefined) {
          this.fatherAction({type: 'onlyGetFiles', files: this.uploader.files, state: 'OnlyGetFiles'})
        }
      } else {
        this.uploader.start()
      }
    },
    beforeUpload: function (file) {
      if (!this.isUploadToCloud) {
        return
      }
      let result = this.resetUploadParams(file)
      if (result === false) {
        this.uploader.removeFile(file)
        if (this.fatherAction) {
          this.fatherAction({type: 'error', error: {message: '您的上传凭证失效，请刷新页面后重试', fileList: [file]}})
        }
      }
      return result
    },
    resetUploadParams: function (file) {
      if (!this.upload.apiURL || !this.upload.savePath) {
        // 恢复数据
        this.resetData()
      }
      let multipartParams = {
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200', // 让服务端返回200,不然，默认会返回204
        callback: '',
        signature: ''
      }
      let host = ''
      let vm = this
      let result = false
      rawRequest({
        method: 'get',
        async: false,
        url: this.upload.apiURL + '/vpi/alicallback/get?path=' + this.upload.savePath,
        success: function (resp) {
          if (resp && resp.dir) {
            let lastName = vm.getLastName(file.name)
            let path = resp.dir + '.' + lastName
            file.relativePath = '/' + path
            multipartParams.key = path
            multipartParams.policy = resp.policy
            multipartParams.OSSAccessKeyId = resp.accessid
            multipartParams.signature = resp.signature
            host = resp.host
            vm.uploader.setOption({
              'url': host,
              'multipart_params': multipartParams
            })
            result = true
          } else {
            console.error('上传policy返回失败！')
          }
        }
      })
      return result
    },
    uploadProgress: function (file) {
      console.log('percent', file.percent)
      if (this.fatherAction) {
        this.fatherAction({type: 'progress', file: file})
      }
    },
    fileUploaded: function (file, info) {
      if (this.isUploadToCloud) {
        let result = {code: info.status === 200 ? 'success' : 'error', body: file}
        this.fatherAction({type: 'fileUploaded', result: result})
      } else {
        let Fn = Function
        let result = new Fn('return (' + info.response + ')')()
        if (this.fatherAction !== undefined) {
          this.fatherAction({type: 'fileUploaded', result: result})
        }
      }
    },
    getLastName: function (name) {
      let index = name.lastIndexOf('.')
      let lastName = index === -1 ? '' : name.substring(index + 1)
      return lastName
    },
    uploadWithFiles: function (files) {
      let _this = this
      files.forEach(function (item) {
        _this.uploader.addFile(item)
      })
      this.uploader.start()
    },
    // 单文件上传时，取消上传
    stopUpload: function (file) {
      this.uploader.stop()
      this.uploader.removeFile(file)
      this.uploader.refresh()
    },
    formatSize: function (size) {
      if (size < 1024) {
        return size + 'B'
      } else if (size < 1024 * 1024) {
        return size / 1024 + 'KB'
      } else {
        return size / 1024 / 1024 + 'MB'
      }
    },
    clearFileList: function () {
      // 清空文件
      this.uploader.stop()
      this.showFileList.forEach(file => {
        if (file.status !== 'error') {
          this.uploader.removeFile(file)
        }
      })
      this.showFileList = []
      this.uploader.refresh()
    }
  }
}
</script>
